import { CircularProgress } from '@mui/material';

import Button from '@/components/Buttons/Button';
import useChartImageExport from '@/components/Chart/hooks/useChartImageExport';
import {
  useExportPreview,
  useExportRequest,
  useExportSettings
} from '@/features/DataHub/modules/Export/context/exportContexts';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

import type { ExportingMimeTypeValue } from 'highcharts';

const ImageFooterButtons = () => {
  const dispatch = useAppDispatch();
  const { previewLoading } = useExportPreview();
  const { capturePosthogEvent } = useExportRequest();
  const { onExport } = useChartImageExport();
  const { exportSettings, updateExportSetting } = useExportSettings();

  const handleButtonClick = () => {
    if (exportSettings.exportSubType) {
      capturePosthogEvent();
      onExport(exportSettings.exportSubType as ExportingMimeTypeValue);
      updateExportSetting('exportSubType', undefined);
    }
  };
  return (
    <>
      <Button
        sx={{
          color: 'primary.main',
          borderColor: 'primary.main'
        }}
        variant='outlined'
        onClick={() => {
          dispatch(closeDrawer());
        }}
      >
        Cancel
      </Button>
      <Button
        disabled={previewLoading}
        startIcon={
          previewLoading ? (
            <CircularProgress
              color='inherit'
              size={16}
            />
          ) : undefined
        }
        variant='contained'
        onClick={handleButtonClick}
      >
        Download
      </Button>
    </>
  );
};

export default ImageFooterButtons;
